export default "__VITE_ASSET__3afbUWIM__"